import { Heading, Paragraph } from '@zillow/constellation-10';

const HandleErrorStatePage = (): JSX.Element | null => (
  <>
    <Heading level={3} textStyle="body-lg-bold">
      We can’t verify your identity right now
    </Heading>
    <Paragraph>
      The process we use to verify identity has failed. You can continue and finish setting up your payments.
    </Paragraph>
  </>
);

export default HandleErrorStatePage;
